import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CallDashboardProvider, useCallDashboard } from 'roger-call-dashboard';
import { Routes } from 'router/routes';

const AWS_CONNECT_URL_CCP = process.env.REACT_APP_CONNECT_URL_CCP!;
const AWS_CONNECT_URL = process.env.REACT_APP_CONNECT_URL!;
const REACT_APP_CALL_DASHBOARD_API = process.env.REACT_APP_CALL_DASHBOARD_API!;

interface ICallDashboardOptionsProps {
  isDashboard: boolean;
  children: React.ReactNode;
}

const CallDashboardOptions: React.FC<ICallDashboardOptionsProps> = ({
  isDashboard,
  children,
}) => {
  const { contact, terminate, isInitialized } = useCallDashboard();

  const {
    connect: { setConnectCanCall },
  } = useDispatch();

  useEffect(() => {
    if (!isDashboard && !contact && isInitialized) {
      terminate();
    }
  }, [isDashboard, contact, terminate]);

  useEffect(() => {
    setConnectCanCall(!contact);
  }, [contact]);

  return children;
};

interface IProps {
  children?: React.ReactNode;
}

const CallDashboardLayout: React.FC<IProps> = ({ children }) => {
  const location = useLocation();

  const isDashboard = location.pathname === Routes.callDashboard;

  return (
    <CallDashboardProvider
      containerId="aws-call-dashboard"
      apiUrl={REACT_APP_CALL_DASHBOARD_API}
      loginUrl={AWS_CONNECT_URL}
      ccpUrl={AWS_CONNECT_URL_CCP}
      outpageShow={!isDashboard}
      outsideShow
    >
      <CallDashboardOptions isDashboard={isDashboard}>
        {children}
      </CallDashboardOptions>
    </CallDashboardProvider>
  );
};

export default CallDashboardLayout;
